import React, { useState, useContext, useEffect, useCallback } from 'react'
import { GlobalStoreContext } from '../../components/store'
import Input from './input'
import get from 'lodash/get'
import Toast from 'Components/toast-messager'
import { getLoginHref } from 'lib/get-login-href'
import { ArticleCardContext } from 'Components/ugc/article-card'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import useLoginCheckCallback from 'Components/hooks/use-login-check-callback'

interface IProps {
  totalCount: number
  aid: number
  appName: string
  gid: string
  author_id: number
  commentArticle?: () => Promise<void>
  titleLeft?: string
  eventBus: any
}

interface InputProps {
  isLogin: boolean
  aid: number
  appName: string
  gid: string
  author_id: number
  avatarUrl: string
  commentArticle?: (commentText: string) => Promise<void>
  eventBus: any
}

let href: string

function CommentInput({
  isLogin,
  aid,
  appName,
  gid,
  author_id,
  avatarUrl,
  commentArticle,
  eventBus,
}: InputProps) {
  const [inputState, setInputState] = useState(false)
  const { inheritNewCard } = useContext(ArticleCardContext)

  function handleCommentClick(content: string) {
    if (commentArticle) {
      commentArticle(content)
        .then(() => {
          sendTeaCommEvent('rt_post_comment', {
            group_id: gid,
            author_id: String(author_id),
            submit_status: '1',
          })

          setInputState(false)
        })
        .catch((e) => {
          sendTeaCommEvent('rt_post_comment', {
            group_id: gid,
            author_id: String(author_id),
            submit_status: '0',
          })
          if (e.message !== '评论内容不能为空！') {
            console.error(e)
          }
        })
    }
  }

  const inputAreaClick = useLoginCheckCallback(
    () => {
      if (!isLogin) {
        Toast.show({
          text: '请先登录再评论~', // 1
        })
      }
    },
    {
      enter_method: 'comment',
    }
  )

  return (
    <div className="container">
      <img
        src={
          avatarUrl ||
          'https://sf1-ttcdn-tos.pstatp.com/obj/motor-img/979a04470557690af95fdb7eb7081e49'
        }
        alt="头像"
      />
      {!inputState ? (
        <div
          className={`input-area ${
            !inheritNewCard ? 'theme-article-detail' : ''
          }`}
          onClick={inputAreaClick}
        >
          <div
            className={`input`}
            onClick={(e) => {
              if (!isLogin) return
              e.preventDefault()
              e.stopPropagation()
              setInputState(true)
            }}
          >
            <div className="tw-flex tw-items-center tw-h-48">
              {!isLogin ? '登录懂车帝，写下您的评论' : '写下您的评论...'}
            </div>
          </div>
          <div
            className="submit"
            onClick={(e) => {
              if (!isLogin) return
              e.stopPropagation()
              e.preventDefault()
              setInputState(true)
            }}
          >
            提交评论
          </div>
        </div>
      ) : (
        <Input text="提交评论" submitClick={handleCommentClick} />
      )}
      <style jsx>
        {`
          .container {
            width: 100%;
            display: flex;
          }
          .container img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
            margin-top: 4px;
          }
          .input-area {
            flex-grow: 1;
            display: flex;
          }
          .input-area .input {
            height: 48px;
            flex-grow: 1;
            padding: 0 20px;
            border-radius: 2px;
            cursor: text;
            background-color: white;
          }
          .input-area .input input {
            background-color: white;
            width: 100%;
            height: 100%;
            font-size: 16px;
            border: none;
            outline: none;
            cursor: text;
            color: #979aa8;
            user-select: none;
          }
          .theme-article-detail {
            border: solid 1px #e6e6e6;
          }
          .container .submit {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 108px;
            height: 48px;
            background-color: #1a1a1a;
            color: white;
            font-size: 16px;
            cursor: pointer;
          }
        `}
      </style>
    </div>
  )
}

function Header({
  totalCount,
  aid,
  appName,
  gid,
  author_id,
  commentArticle,
  eventBus,
  titleLeft,
}: IProps) {
  const { state } = useContext(GlobalStoreContext)
  const userName = get(state, 'userData.name')
  const avatarUrl = get(state, 'userData.avatar_url')
  const isLogin = userName ? true : false
  const { inheritNewCard } = useContext(ArticleCardContext)

  useEffect(() => {
    href = getLoginHref()
  }, [])

  return (
    <div className="comment-container">
      {!inheritNewCard && (
        <div className="title">
          <div className="tilte-left">
            {`${titleLeft || '评论'} ⋅ ${totalCount || 0}`}
          </div>
        </div>
      )}
      <div className="reply">
        <CommentInput
          isLogin={isLogin}
          aid={aid}
          appName={appName}
          gid={gid}
          author_id={author_id}
          avatarUrl={avatarUrl}
          commentArticle={commentArticle}
          eventBus={eventBus}
        />
      </div>
      <style jsx>
        {`
          .comment-container {
            margin-bottom: 20px;
          }
          .title {
            width: 100%;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #1a1a1a;
            border-bottom: 1px solid #e6e6e6;
            margin-bottom: 30px;
            margin-top: 30px;
          }

          .tilte-left {
            font-size: 24px;
            font-weight: 500;
          }

          .tilte-right {
            display: flex;
            align-items: center;
          }

          .tilte-right .user-name,
          .tilte-right .login {
            font-size: 16px;
            line-height: 22px;
          }

          .tilte-right .login {
            cursor: pointer;
          }

          .tilte-right .login:hover {
            color: rgb(58, 76, 102);
          }

          .tilte-right .split-line {
            width: 1px;
            height: 20px;
            border: solid 1px #e6e6e6;
            margin: 0 8px;
          }

          .tilte-right img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
        `}
      </style>
    </div>
  )
}

export default Header
